import type { TUserRoleKey } from '@lib/enums/UserRoleKeyEnum';
import type { TUserRole } from '@models/authorization/TUserRole';

export function hasAnyRole(
  roles: readonly TUserRole[],
  roleKeys: readonly TUserRoleKey[],
): boolean {
  return roles.some(({ roleKey }) => roleKeys.some((key) => key === roleKey));
}
